import { useState } from 'react';
import * as React from 'react';
import { personalakteStyles as ps, colors, shadows } from '../styles/personalakteStyles';

interface ChangePasswordModalProps {
  open: boolean;
  onClose: () => void;
  mode: 'single' | 'bulk';
  employeeName?: string;
  selectedCount?: number;
  onSubmit: (password: string) => void;
  busy?: boolean;
}

const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle: React.CSSProperties = {
  background: colors.bgCard,
  padding: '24px',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '400px',
  boxShadow: shadows.elevated,
};

function ChangePasswordModal({ open, onClose, mode, employeeName, selectedCount, onSubmit, busy }: ChangePasswordModalProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const handleClose = () => {
    setPassword('');
    setError('');
    onClose();
  };

  const handleSubmit = () => {
    if (!password) {
      setError('Bitte geben Sie ein Passwort ein');
      return;
    }
    if (password.length < 8) {
      setError('Mind. 8 Zeichen.');
      return;
    }
    onSubmit(password);
    setPassword('');
    setError('');
  };

  const title = mode === 'single'
    ? `Change Password for ${employeeName}`
    : `Change Password for ${selectedCount} employee(s)`;

  const isBulk = mode === 'bulk';
  const isDisabled = isBulk
    ? !password || password.length < 8 || busy
    : !password;

  return (
    <div style={modalOverlayStyle} onClick={handleClose}>
      <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ margin: 0, color: colors.navy, fontSize: 16, fontWeight: 700 }}>{title}</h3>
          <button
            onClick={handleClose}
            style={{
              background: colors.bgMuted,
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: colors.textMuted,
              padding: '0',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = colors.bgHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = colors.bgMuted; }}
            title="Close"
          >
            ×
          </button>
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label style={ps.labelStyle}>New Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={ps.inputStyle}
            placeholder={isBulk ? 'Min. 8 characters' : 'Enter new password'}
          />
          {isBulk && password.length > 0 && password.length < 8 && (
            <div style={{ color: colors.danger, fontSize: 11, marginTop: 4 }}>Min. 8 characters</div>
          )}
        </div>
        {error && !isBulk && (
          <div style={{ color: 'red', marginBottom: '15px' }}>{error}</div>
        )}
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            className="hover-btn-secondary"
            onClick={handleClose}
            style={ps.buttonSecondary}
          >
            Cancel
          </button>
          <button
            className="hover-btn-primary"
            onClick={handleSubmit}
            style={{
              ...ps.buttonPrimary,
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
            disabled={isDisabled}
          >
            {isBulk
              ? (busy ? 'Setting...' : `Set for ${selectedCount} employee(s)`)
              : 'Change PW'
            }
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
